// Centralized TanStack Query key factory: keeps invalidations aligned with
// consumers instead of scattering `["rule", id]` literals across call sites.

export const ruleQueryKey = (ruleId) => ["rule", ruleId];
export const allEntitiesQueryKey = () => ["all-entities"];
export const operatorsQueryKey = () => ["operators"];
export const functionsQueryKey = () => ["functions"];
export const displayedEntitiesQueryKey = (queryId) => [
  "displayed-entities",
  queryId,
];
